<style lang="scss">
.input-footer-menu-list {
  visibility: hidden;
  margin: 10px 0 10px -10px;
}
.input-preview:hover {
  .input-footer-menu-list {
    visibility: visible;
  }
}
.input-footer-menu-bottom {
  margin: 20px 0;
  border-top: 1px dashed #aaa;
}
.input-footer-menu-add,
.input-footer-menu-close {
  font-size: 1rem;
  text-decoration: underline;
  display: inline-block;
  position: relative;
  top: -8px;
  background: white;
  padding: 0 10px;
}
.input-footer-menu-add-item {
  margin-bottom: 10px;
}
.editor-menu-link {
  font-size: 10px;
}
</style>

<template>
  <div class="input-footer-menu">
    <ul class="input-footer-menu-list clearfix">
      <li class="input-footer-menu-item">
        <a class="btn-green" @click="onBeginEdit()">編集</a>
      </li>
      <li class="input-footer-menu-item">
        <a class="btn-green" @click="onDeleteInput()">削除</a>
      </li>
      <li class="input-footer-menu-item">
        <a @click="onPullUp()" class="btn-green">上に</a>
      </li>
      <li class="input-footer-menu-item">
        <a @click="onPullDown()" class="btn-green">下に</a>
      </li>
      <li v-if="onPullUpGroup" class="input-footer-menu-item">
        <a @click="onPullUpGroup()" class="btn-green">まとめて上に</a>
      </li>
      <li v-if="onPullDownGroup" class="input-footer-menu-item">
        <a @click="onPullDownGroup()" class="btn-green">まとめて下に</a>
      </li>
    </ul>
    <div class="input-footer-menu-bottom clearfix">
      <div class="pull-right">
        <a v-if="!isOpen" class="input-footer-menu-add" @click.prevent="onOpen"
          >ここに追加</a
        >
        <a v-if="isOpen" class="input-footer-menu-close" @click="isOpen = false"
          >閉じる</a
        >
      </div>
    </div>
    <div class="input-footer-menu-add-item">
      <ul class="editor-menu-list clearfix" v-show="isOpen">
        <li class="editor-menu-item">
          <a class="editor-menu-link" @click="addItem('header')">
            <i class="fa fa-header"></i>
            見出し
          </a>
        </li>
        <li class="editor-menu-item">
          <a class="editor-menu-link" @click="addItem('text')">
            <i class="fa fa-pencil"></i>
            テキスト
          </a>
        </li>
        <li class="editor-menu-item">
          <a class="editor-menu-link" @click="addItem('table')">
            <i class="fa fa-table"></i>
            表
          </a>
        </li>
        <li class="editor-menu-item">
          <a class="editor-menu-link" @click="addItem('review')">
            <i class="fa fa-comment-o"></i>
            クチコミ
          </a>
        </li>
        <li class="editor-menu-item">
          <a class="editor-menu-link" @click="addItem('quote')">
            <i class="fa fa-quote-right"></i>
            引用
          </a>
        </li>
        <li class="editor-menu-item">
          <a class="editor-menu-link" @click="addItem('link')">
            <i class="fa fa-link"></i>
            リンク
          </a>
        </li>
        <li class="editor-menu-item">
          <a class="editor-menu-link" @click="addItem('post-links')">
            <i class="fa fa-book"></i>
            記事リスト
          </a>
        </li>
        <li class="editor-menu-item">
          <a class="editor-menu-link" @click="addItem('external-post-links')">
            <i class="fa fa-external-link-square"></i>
            他メディアリスト
          </a>
        </li>
        <li class="editor-menu-item">
          <a class="editor-menu-link" @click="addItem('image')">
            <i class="fa fa-file-image-o"></i>
            画像
          </a>
        </li>
        <li class="editor-menu-item">
          <a class="editor-menu-link" @click="addItem('store')">
            <i class="fa fa-building"></i>
            店舗
          </a>
        </li>
        <li class="editor-menu-item">
          <a class="editor-menu-link" @click="addItem('general-product')">
            <i class="fa fa-shopping-bag"></i>
            商品
          </a>
        </li>
        <li class="editor-menu-item">
          <a class="editor-menu-link" @click="addItem('twitter')">
            <i class="fa fa-twitter"></i>
            Twitter
          </a>
        </li>
        <li class="editor-menu-item">
          <a class="editor-menu-link" @click="addItem('insta')">
            <i class="fa fa-instagram"></i>
            Instagram
          </a>
        </li>
        <li class="editor-menu-item">
          <a class="editor-menu-link" @click="addItem('youtube')">
            <i class="fa fa-youtube"></i>
            YouTube
          </a>
        </li>
        <li class="editor-menu-item">
          <a class="editor-menu-link" @click="addItem('product')">
            <i class="fa fa-amazon"></i>
            Amazon
          </a>
        </li>
        <li class="editor-menu-item">
          <a class="editor-menu-link" @click="addItem('talk')">
            <i class="fa fa-vcard"></i>
            会話
          </a>
        </li>
        <li class="editor-menu-item">
          <a class="editor-menu-link" @click="addItem('map')">
            <i class="fa fa-google"></i>
            Map
          </a>
        </li>
        <li class="editor-menu-item">
          <a class="editor-menu-link" @click="addItem('html')">
            <i class="fa fa-file"></i>
            HTML
          </a>
        </li>
        <li class="editor-menu-item">
          <a class="editor-menu-link" @click="addItem('faq')">
            <i class="fa fa-question"></i>
            FAQ
          </a>
        </li>
        <li class="editor-menu-item">
          <a class="editor-menu-link" @click="addItem('coupon')">
            <i class="fa fa-cube"></i>
            クーポン
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    onDeleteInput: Function,
    onPullUp: Function,
    onPullDown: Function,
    onPullUpGroup: Function,
    onPullDownGroup: Function,
    onBeginEdit: Function,
    index: Number,
  },
  data() {
    return {
      isOpen: false,
    };
  },
  methods: {
    addItem(item) {
      this.isOpen = false;
      bus.$emit('add-item', item, this.index);
    },
    onOpen() {
      this.isOpen = true;
      this.$el.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
        inline: 'center',
      });
    },
  },
};
</script>
